export default "__VITE_ASSET__a5c416c5__"